<section class="mt-3">
  <!-- Input para filtrar datos -->
  <div class="row">
    <mat-form-field class="col-12 col-md-4">
      <mat-label>Filtrar</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar por Obra, Ubicación o Propietario" #input />
    </mat-form-field>
    <mat-form-field class="col-12 col-md-4">
      <mat-label>Filtro Estatus</mat-label>
      <mat-select [(ngModel)]="selectedStatus" (selectionChange)="filterByStatus($event.value)">
        <mat-option>--</mat-option>
        <mat-option *ngFor="let es of estatus" [value]="es.idEstatus">{{ es.descripcion }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Tabla Historial Cotizaciones -->
  <table mat-table [dataSource]="dataSource" class="w-100 table-hover table-responsive-md">
    <!--Columna Obra-->
    <ng-container matColumnDef="obra">
      <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>
        Obra
      </th>
      <td mat-cell *matCellDef="let element" [routerLink]="['./detalle-cotizacion', element.idCotizacion]">
        {{ element.obra }}
      </td>
    </ng-container>

    <!--Columna Estatus-->
    <ng-container matColumnDef="estatus">
      <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>
        Estatus
      </th>
      <!-- <td mat-cell *matCellDef="let element">
        <mat-chip-list arie-label="Estatus">
          <mat-chip color="primary" selected>{{ element.estatus }}</mat-chip>
        </mat-chip-list>
      </td> -->
      <td mat-cell *matCellDef="let element">
        <span class="badge badge-pill badge-secondary" *ngIf="element.idEstatus == 1">{{element.estatus}}</span>
        <span class="badge badge-pill badge-info" *ngIf="element.idEstatus == 2">{{element.estatus}}</span>
        <span class="badge badge-pill badge-success" *ngIf="element.idEstatus == 3">{{element.estatus}}</span>
        <span class="badge badge-pill badge-danger clickable-span" *ngIf="element.idEstatus == 4" (click)="getTimelineReject(element.idCotizacion)">{{element.estatus}}</span>
        <span class="badge badge-pill badge-danger" *ngIf="element.idEstatus == 5">{{element.estatus}}</span>
        <span class="badge badge-pill badge-success" *ngIf="element.idEstatus == 6">{{element.estatus}}</span>
      </td>
    </ng-container>

    <!--Columna Ubicación-->
    <ng-container matColumnDef="ubicacion">
      <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>
        Ubicación
      </th>
      <td mat-cell *matCellDef="let element">{{ element.ubicacion }}</td>
    </ng-container>

    <!--Columna Propietario-->
    <ng-container matColumnDef="propietario">
      <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>
        Propietario
      </th>
      <td mat-cell *matCellDef="let element">{{ element.propietario }}</td>
    </ng-container>

    <!--Columna Fecha Creación-->
    <ng-container matColumnDef="fechaCreacion">
      <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>
        Fecha Creación
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.fechaCreacion | date: "medium" }}
      </td>
    </ng-container>

    <!--Columna Fecha Aprobación-->
    <!-- <ng-container matColumnDef="fechaAprobacion">
      <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>
        Fecha Aprobación
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.fechaAprobacion | date: "medium" }}
      </td>
    </ng-container> -->

    <!--Columna Opciones-->
    <ng-container matColumnDef="opciones">
      <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>
        Opciones
      </th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button color="primary" [routerLink]="['./detalle-cotizacion', element.idCotizacion]"
          matTooltip="Ver Detalles">
          <mat-icon>remove_red_eye</mat-icon>
        </button>
        <!-- <button
          mat-icon-button
          color="primary"
          (click)="updateEstatus(element.idCotizacion)"
          *ngIf="element.idEstatus === 1"
          matTooltip="Solicitar Autorización"
        >
          <mat-icon>credit_card</mat-icon>
        </button>
        <button
          mat-icon-button
          color="primary"
          [routerLink]="['/pago-online']"
          *ngIf="element.idEstatus === 3"
          matTooltip="Ir a pagar"
        >
          <mat-icon>attach_money</mat-icon>
        </button> -->
        <button [disabled]="element.idEstatus !== 1 && element.idEstatus !== 3 && element.idEstatus !== 4" mat-icon-button color="accent"
          [routerLink]="['/cotizaciones/editar/', element.idCotizacion]" matTooltip="Editar cotización">
          <mat-icon>create</mat-icon>
        </button>
        <button [disabled]="element.idEstatus !== 1 && element.idEstatus !== 4" mat-icon-button color="primary" (click)="getReview(element.idCotizacion)" matTooltip="Enviar a revisión">
          <mat-icon>near_me</mat-icon>
        </button>
        <button [disabled]="element.idEstatus !== 3" mat-icon-button color="primary" (click)="updateEstatus(element.idCotizacion)" matTooltip="Ir a pagar">
          <mat-icon>credit_card</mat-icon>
        </button>
        <button mat-icon-button color="accent" (click)="imprimirPDF(element.idCotizacion)"
          matTooltip="Imprimir cotización">
          <mat-icon>print</mat-icon>
        </button>
        <button [disabled]="element.idEstatus !== 1 && element.idEstatus !== 4 && element.idEstatus !== 5" mat-icon-button color="warn" matTooltipPosition="above"
          matTooltip="Eliminar cotización" (click)="deleteCotizacion(element.idCotizacion)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Otros iconos:
    avion tal cual: local_airport -->

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <!-- End Tabla Historial Cotizaciones -->

  <!-- Div a mostrar cuando estén cargando los datos -->
  <div class="alert alert-light text-center" *ngIf="loading">
    <p class="d-flex justify-content-center">
      <mat-spinner></mat-spinner>
    </p>
  </div>

  <!-- Div a mostrar cuando no encuentre coincidencias -->
  <div class="alert" role="alert" *ngIf="!loading && dataSource.filteredData.length === 0">
    No se han encontrado resultados para: {{ input.value }}
  </div>

  <!-- Div a mostrar cuando no haya datos -->
  <div class="alert alert-info text-center" *ngIf="!loading && dataSource.data.length === 0">
    <p>
      <mat-icon class="icon-material">info</mat-icon>
    </p>
    <h4 class="alert-heading">No hay datos para mostrar</h4>
  </div>

  <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</section>